import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { DriverInDeliveriesListItem } from "../../financial.types";
import { requestAllDriversDeliveriesInfo } from "./getDriversDeliveriesInfo.request";
import { GetDriversDeliveriesInfoRequestParams } from "./getDriversDeliveriesInfo.types";

const useGetDriversDeliveriesInfo = (
  params: GetDriversDeliveriesInfoRequestParams,
  options?: QueryOptions<
    DriverInDeliveriesListItem[],
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["driver", "admin", "all-with-delivery-calculations", params],
    queryFn: async () => await requestAllDriversDeliveriesInfo(params),
    onError: toastServerError,
    ...options
  });

  return { driversDeliveriesInfo: data, ...rest };
};

export default useGetDriversDeliveriesInfo;
